import { render, staticRenderFns } from "./ModalDeleteVm.vue?vue&type=template&id=46e5878b&scoped=true&lang=html&"
import script from "./ModalDeleteVm.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteVm.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteVm.vue?vue&type=style&index=0&id=46e5878b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e5878b",
  null
  
)

export default component.exports